import type { PropsOf } from '@emotion/react'
import type { FC } from 'react'
import { useParams } from 'react-router-dom'

import List from '@app/pages/strategies/components/aiChat/list'

type Props = Omit<PropsOf<typeof List>, 'chattableType' | 'chattableId'>

const RoutedList: FC<Props> = (props) => {
  const { strategyId } = useParams()

  return <List chattableType="Strategy" chattableId={strategyId} {...props} />
}

export default RoutedList
